var experiences = [
  {
    id: 0,
    positions: [
      {
        title: "AI Intern",
        description: [
          "Formulated automated spreadsheets to analyze the accuracy of custom AI models built using consumer data",
          "Conducted and presented research on business-to-business (B2B) growth plans to senior executives",
        ],
        dates: "June 2018 - Aug. 2018",
        type: "Internship",
      },
    ],
    company: "StataPile: AI Quality Assurance",
    location: "Chicago, IL",
    url: "https://statapile.com/",
    linkedin: "https://www.linkedin.com/search/results/all/?keywords=StataPile",
    headerImage: "https://willfeldman.com/src/statapile_background.png",
    logo: "https://willfeldman.com/src/statapile_logo.png",
    additionalInformation: `
    <div>
      <p>
        During my internship at StataPile, an AI firm that focuses on
        analyzing call center recordings for quality assurance and process
        optimizations, I worked on the rapidly growing
        field of artificial intelligence. This experience
        provided valuable early exposure to the AI industry. My primary
        responsibility involved creating sophisticated spreadsheets, allowing
        for a detailed analysis of the AI model's accuracy in interpreting consumer
        data. This task honed my analytical skills and deepened my
        understanding of how AI works and its applications in real-world scenarios.
      </p>
      <p>
        In addition to model analysis, I took the initiative to revamp the
        company's website backend. This redesign significantly enhanced the user
        experience for employees, streamlining their interaction with our systems
        and improving overall efficiency.
      </p>
      <p>
        My role also extended to conducting in-depth research on
        business-to-business (B2B) growth strategies. The culmination of this
        project was a presentation of my findings to the executive team, offering insights
        that shaped the company's future growth plans.
      </p>
    </div>
    `,
  },
  {
    id: 1,
    positions: [
      {
        title: "Web Developer",
        description: [
          "Designed and programmed websites for two local DJ companies, Matt Ryan Mobile DJ Entertainment and AUDiO-PRO Mobile DJ Entertainment, as well as several smaller companies",
          "Communicated and met frequently with clients to display progress and make adjustments",
          "Maintained the sites and updated site information on an as-needed basis",
        ],
        summary:
          "Designed and programmed 5 websites for local businesses using HTML, CSS, JavaScript, PHP, and jQuery",
        dates: "Apr. 2017 - Aug. 2020",
        type: "Part-time",
      },
    ],
    company: "Freelance",
    location: "Columbus, OH",
    url: ["https://mattryandj.com", "https://audiopromobiledj.com"],
    headerImage: "https://willfeldman.com/src/matt_ryan_background.png",
    logo: "https://willfeldman.com/src/matt_ryan_logo.jpeg",
    additionalInformation: `
    <div>
      <p>
        I did part-time work as a freelance web
        developer, catering to local businesses in Columbus. My first significant
        project was for Matt Ryan Mobile DJ Entertainment, one of the premier event
        DJs in central Ohio. I self-learned coding during middle school, utilizing YouTube videos,
        online tutorials, and books. The owner of the DJ
        company noticed my work and reached out to me regarding
        freelance services.
      </p>
      <p>
        The project involved many meetings and back-and-forth discussions. This task
        not only tested my technical skills but also honed my ability to understand
        and translate client needs into a functional and aesthetically pleasing
        online presence. The success of this project led to a referral to another
        prominent DJ in Columbus, for whom I also created a website.
      </p>
      <p>
        Beyond these two major projects, I undertook several smaller assignments,
        including developing landing pages and websites for various Columbus
        companies. I continued to maintain and update these sites over the years,
        ensuring their relevance and effectiveness. This experience was foundational
        in my development as a web developer, combining self-taught skills with
        real-world application, client interaction, and the ability to adapt to
        business needs.
      </p>
    </div>
    `,
  },
  {
    id: 2,
    positions: [
      {
        title: "Founder",
        description: [
          "Launched and led a clothing brand that sold $7,000 worth of hand-made merchandise",
          "Directed related business, web development, graphic design, marketing, and social media sectors",
        ],
        dates: "Aug. 2019 - Aug. 2020",
        type: "Part-time",
      },
    ],
    company: "pausecircleplay",
    location: "Columbus, OH",
    url: "https://www.pausecircleplay.com/",
    linkedin: "https://www.linkedin.com/company/pausecircleplay/",
    headerImage: "https://willfeldman.com/src/pcp_background.png",
    logo: "https://willfeldman.com/src/pcp_logo.jpeg",
    additionalInformation: `
    <div>
      <p>
        I founded pausecircleplay, a lifestyle and
        streetwear clothing brand. This venture began with an investment of just $30
        in screen printing materials. I self-taught myself the process by utilizing
        videos online.
      </p>
      <p>
        pausecircleplay encapsulated a philosophy I resonated with: 'pause' to take
        a deep breath, 'circle' to reflect, and 'play' to live your best life. This
        motto became the cornerstone of the
        brand's identity. For the initial launch, I enlisted friends for help with
        photo shoots, then leveraged the content on my website and social media.
        This grassroots marketing strategy paid off, as the brand gained traction
        within my high school, spreading rapidly through word-of-mouth.
      </p>
      <p>
        Following the initial success, I reinvested the profits to purchase a vinyl
        cutting machine, expanding the product line to include sweatshirts and
        crewnecks with iron-on vinyl designs. My hands-on approach, from screen
        printing to website development and photography, including studio shoots,
        was critical in maintaining the brand's authenticity and appeal.
      </p>
      <p>
        The defining moment for pausecircleplay came with a feature on a nightly
        special by Columbus' local news station. This exposure catapulted the brand,
        leading to sales from across the country, fueling sales that soared to
        $7,000 in revenue. 10% of all proceeds were donated to charities.
      </p>
      <p>
        With the transition to college life, I made the tough decision to end the
        business. The brand's essence, rooted in personally designed and handcrafted
        products, was something I was unwilling to let go of, and I did not have the
        space or time to continue in college. This journey through pausecircleplay
        was a valuable learning experience in entrepreneurship, marketing, and the
        value of a personal touch in business.
      </p>
    </div>
    `,
  },
  {
    id: 3,
    positions: [
      {
        title: "Unified Communications & Technology Specialist",
        description: [
          "Installed and configured hundreds of touchscreen VoIP phones with integrated video conferencing capabilities across the campus, enhancing communication infrastructure",
          "Produced 10 high-quality instructional videos to guide university staff in operating new communication equipment to improve user adoption and reduce support requests",
        ],
        summary:
          "Enhanced communication infrastructure through the installation & enablement of hundreds of VoIP phones...",
        dates: "Jan. 2021 - May 2021",
        type: "Part-time",
      },
    ],
    company: "Northeastern University ITS",
    location: "Boston, MA",
    url: "https://its.northeastern.edu",
    linkedin:
      "https://www.linkedin.com/company/northeastern-university-information-technology-services/",
    headerImage: "https://willfeldman.com/src/its_background.jpeg",
    logo: "https://willfeldman.com/src/its_logo.jpeg",
    additionalInformation: `
    <div>
      <p>
        During my time at Northeastern University's Information Technology Services
        (ITS) department, I played a significant role in the campus-wide transition
        from traditional landlines to a Voice over Internet Protocol (VoIP)
        communication system. This part-time position, which I did while in classes,
        provided a unique opportunity to blend theoretical learning with practical,
        hands-on experience.
      </p>
      <p>
        My primary responsibility entailed the installation of hundreds of Microsoft
        Teams-enabled VoIP phones across various university facilities, including
        offices, classrooms, and labs. This task required learning technical
        telecommunication skills and how to approach addressing the needs of
        professors and administrative staff. The project was significant in its
        scale and impact, modernizing the university's communication infrastructure
        and enhancing connectivity across the campus.
      </p>
      <p>
        Apart from the installations, I contributed to the smooth transition by
        producing and filming 10 professional instructional guides. These guides
        played a helpful role in familiarizing the university community with the new
        system, ensuring a seamless adaptation to the VoIP technology.
      </p>
      <p>
        An integral part of this project also involved the removal of outdated
        landline phones and their associated wiring. This task involved the use of
        specialized telecommunication equipment to identify and safely remove
        obsolete wires. The experience was further enriched by the mentorship of a
        veteran telecommunications expert, a former early Verizon employee who
        worked at the company for almost 30 years, hired to oversee much of
        Northeastern’s technology. Under his guidance, I gained invaluable insights
        into corporate transformations and the evolution of telecommunications,
        enhancing my practical knowledge and technical skills.
      </p>
    </div>
    `,
  },
  {
    id: 4,
    positions: [
      {
        title: "Project Intern",
        description: [
          "Improved estimate accuracy in ERP system by conducting over 30 hours of manufacturing time studies",
          "Coordinated the distribution of 3,000+ drawings from the engineering team to the manufacturing team",
        ],
        dates: "June 2021 - Aug. 2021",
        type: "Internship",
      },
    ],
    company: "N. Wasserstrom & Sons",
    location: "Columbus, OH",
    url: "https://www.wasserstrom.com/restaurant-supplies-equipment/n-wasserstrom-and-sons",
    linkedin: "https://www.linkedin.com/company/n-wasserstrom-sons/",
    headerImage: "https://willfeldman.com/src/wasserstrom_hq_header.jpg",
    logo: "https://willfeldman.com/src/wasserstrom_logo.png",
    additionalInformation: `
    <div>
      <p>
        At Wasserstrom, a leading engineering and manufacturing provider in the food
        service equipment industry, my role as an intern involved enhancing the
        efficiency and accuracy of project planning. Wasserstrom, known for working
        with a vast array of clients from the largest national restaurant chains to
        independent establishments, often encounters the challenge of pricing custom
        equipment orders.
      </p>
      <p>
        My primary contribution was to improve the Enterprise Resource Planning
        (ERP) system, which plays a crucial role in generating accurate quotes for
        custom orders. Throughout my internship, I spent more than 30 hours
        measuring the time required to construct specific parts of equipment. This
        involved learning many parts of the manufacturing process. I then organized
        and analyzed the raw observations and measurements into insights that will
        be used in future project quoting.
      </p>
      <p>
        Additionally, I facilitated effective collaboration between the engineering
        and manufacturing teams. I acted as a bridge, ensuring both teams on-site
        had the necessary resources to start designing and building parts. This
        coordination helped streamline the production process and contributed to
        Wasserstrom's capacity to deliver high-quality, custom equipment in a timely
        and cost-effective manner.
      </p>
    </div>
    `,
  },
  {
    id: 5,
    positions: [
      {
        title: "Product Manager Co-op",
        description: [
          "Led a web performance-focused 4-person scrum team that improved client performance by an average of 80.2%",
          "Improved an admin tool clients use to control hundreds of settings and content on websites",
          "Directed a $60,000 purchasing decision for software that speeds up the process of making internal tooling",
          "Created dozens of product briefs detailing the scope and direction of products",
          "Regularly met and communicated with several internal and external stakeholders of projects for collaboration",
        ],
        dates: "Jan. 2022 - July 2022",
        type: "Full-time",
      },
    ],
    company: "Blueport Commerce",
    location: "Boston, MA",
    additionalInformation: `
    <div>
      <div>
      <p>
        During my time at Blueport Commerce as a Product Manager, I had the
        opportunity to engage in a range of tasks that significantly contributed to
        the company's growth and operational efficiency. Blueport Commerce
        specializes in e-commerce platforms for large furniture retailers, a sector
        with distinct challenges due to the high value of its online sales and the
        necessity for an omnichannel approach.
      </p>
      <p>
        One of my key responsibilities involved exploring and recommending headless
        Content Management Systems (CMS) to enhance our e-commerce solutions. This
        involved seeking CMS options that supported drag-and-drop capabilities for
        webpage building, enabling our clients, some of whom lacked technical
        expertise, to build custom pages using Angular components. Additionally, I
        focused on internal tooling to expedite the creation of tools for our team
        and clients, such as a tool for editing menu nodes, which were part of our
        custom-built client system, Hub​​. The latter project ended with a purchase
        of Retool to speed up our development processes.
      </p>
      <p>
        I also conducted web vital tests on our client’s product display pages and
        product listing pages, analyzing scripts to identify and address performance
        issues. I was involved in the decision-making process for utilizing
        automated testing services for continuous speed monitoring​​.
      </p>
      <p>
        A notable achievement was my management in a 4-person scrum team that led to
        a significant improvement in Total Blocking Time (TBT), one of the core web
        vitals, on search pages with many results. For a product display page with
        95 results, the TBT was reduced by 74.5%, from 7.118s to 3.256s. This was
        accomplished by dividing the single search call into two separate calls, one
        of which was delayed to enhance the site's performance and user
        experience​​.
      </p>
      <p>
        The skills I gained in Jira and Confluence for sprint management, along with
        the exposure to tech company organization and prioritization, were
        invaluable, especially in my first full-time role in Product Management. I
        continued at Blueport as an Associate Product Manager the summer following
        the co-op. This experience not only honed my technical skills but also
        provided a practical application of my studies, particularly in
        understanding the organizational and prioritization aspects of being a
        Product Manager.
      </p>
    </div>
    <div className="presentations">
      <div className="pdf">
        <h3 className="documentTitle">Core Web Vitals Project</h3>
        <iframe
          title="Blueport Core Web Vitals Project"
          src="https://drive.google.com/viewerng/viewer?url=https://willfeldman.com/src/documents/core-web-vitals.pdf&embedded=true"
          frameBorder="0"
        ></iframe>
      </div>
      <div className="pdf">
        <h3 className="documentTitle">Final Presentation</h3>
        <iframe
          title="Blueport Final Presentation"
          src="https://drive.google.com/viewerng/viewer?url=https://willfeldman.com/src/documents/coop-final-presentation.pdf&embedded=true"
          frameBorder="0"
        ></iframe>
      </div>
    </div>
    </div>
  `,
    url: "https://www.blueport.com",
    linkedin: "https://www.linkedin.com/company/blueport-commerce/",
    headerImage: "https://willfeldman.com/src/blueport_header.png",
    logo: "https://willfeldman.com/src/blueport_logo.jpeg",
  },
  {
    id: 6,
    positions: [
      {
        title: "Web Strategist",
        description: [
          "Assisted in scoping, planning, and delivering web projects by partnering with project stakeholders, building development schedules, and tracking progress against key metrics",
          "Streamlined the order modification processes for rush cases, address changes, and product swaps to speed up the response time of 600 order modifications by nearly 70%",
          "Implemented multiple automation initiatives that effectively streamlined manual procedures, ultimately saving approximately 40 employee hours weekly",
        ],
        summary:
          "Assisted in scoping, planning, and delivering web projects to increase eCommerce sales and go-lives",
        dates: "Jan. 2023 - June 2023",
        type: "Full-time",
      },
      {
        title: "Associate Product Manager",
        description: [
          "Oversaw management for New Business eCommerce initiatives, driving enhancements in online sales processes, improving customer experience, and enabling cross-functional teams to achieve strategic business goals",
          "Drove $120,000 ARR growth by introducing add-on terminal options and SaaS charges for eCommerce customers, expanding product upsell opportunities",
          "Managed the pilot and discovery of Quote Builder, aimed at automating quote creation for thousands of sales reps and projected to bring significant ARR growth, targeting a full launch in 2025",
        ],
        summary:
          "Spearhead the management of the eCommerce prospect flow to ensure a seamless online purchasing experience",
        dates: "June 2023 - Apr. 2025",
        type: "Full-time",
      },
      {
        title: "Product Manager",
        description: [
          "Overseeing internal tooling and digital signing experiences, including Cart Builder, an internal upsell tool that has processed over 10k deals and driven $2.7M ARR, serving various teams from sales to customer care",
          "Developed and launched Quote Builder from initial pilot to full-scale rollout, streamlining prospect sales quoting through automated pricing, configuration, and Salesforce integration, reducing manual effort and accelerating the sales cycle for over 1k new business deals",
        ],
        summary:
          "Driving the strategy and execution of internal sales tools and digital signing experiences at scale",
        dates: "Apr. 2025 - Present",
        type: "Full-time",
      },
    ],
    company: "Toast",
    location: "Boston, MA",
    fullDates: "Jan. 2023 - Present",
    url: "https://pos.toasttab.com",
    linkedin: "https://www.linkedin.com/company/toast-inc/",
    headerImage: "https://willfeldman.com/src/toast_background.jpeg",
    logo: "https://willfeldman.com/src/toast_logo.jpeg",
    additionalInformation: `
    <div>
      <p>
        In my roles at Toast, my contributions range from automating complex processes to 
        leading AI-driven initiatives, continually transforming how the eCommerce team conducts 
        business and interacts with customers.
      </p>
      <p>
        A key achievement is the overhaul of the eCommerce reporting system. Addressing the 
        challenges of manual tracking amidst a surge in deals, I lead the development of an automated 
        tracking and reporting system. Utilizing Salesforce, Google App Scripts, JavaScript, Zapier, and 
        Salesforce Connector, this new tool streamlines data management, significantly reduces errors, and 
        scales to accommodate growing transaction volumes.
      </p>
      <p>
        I have also optimized the deal-claiming process for the Online Sales Team. Replacing a cumbersome, 
        multi-spreadsheet system with a single, efficient form, I've dramatically reduced the time each team 
        member spends on administrative tasks by 30 minutes daily, cumulatively saving the team almost 38 hours 
        per week. This enhancement not only boosts productivity but also improves the accuracy of deal assignments.
      </p>
      <p>
        Another ongoing project is the development of a customer chatbot, instrumental in increasing the 
        customer contract task completion rate by 8%. This tool, capable of handling 45 common queries and 
        integrated with an automated follow-up system, engages 11% of eCommerce customers, ensuring timely support and 
        boosting task completion rates.
      </p>
      <p>
        I regularly present my projects to cross-functional teams, fostering a culture of transparency and collaboration. 
        My presentations in Web Team Standup and eComm Leads Meetings are critical in aligning strategies and sharing insights.
      </p>
      <p>
        My active involvement in AI-driven projects is a highlight of my role. I have contributed to a customer-centric prototype 
        for our company-wide hackathon, receiving recognition and potential prioritization. Additionally, I am conducting an AI 
        analysis of the chatbot responses for optimization, showcasing the potential of AI in operational contexts.
      </p>
      <p>
        Supporting the Online Sales Team, I efficiently manage order modifications in Salesforce, addressing expedited shipments and 
        other adjustments. This hands-on assistance significantly enhances customer satisfaction and order processing efficiency.
      </p>
      <p>
        I also managed the returned-to-sender process, directly interacting with customers to resolve order issues, thereby recovering 
        potential lost sales and enhancing customer experience. My time at Toast is marked by these multifaceted contributions, 
        showcasing my ability to innovate, streamline, and enhance both internal processes and customer interactions.
      </p>
    </div>

    `,
  },
];

module.exports = { experiences };
